import {fonts as fontTheme, fontPrimary, fontSecondary, fontTertiary} from '@helios/shared/theme'

import neueHaasGroteskDisplay_55RomanWoff from '../fonts/neue-haas-grotesk-display-55-roman.woff'
import neueHaasGroteskDisplay_55RomanWoff2 from '../fonts/neue-haas-grotesk-display-55-roman.woff2'
import neueHaasGroteskDisplay_56RomanItalicWoff from '../fonts/neue-haas-grotesk-display-56-roman-italic.woff'
import neueHaasGroteskDisplay_56RomanItalicWoff2 from '../fonts/neue-haas-grotesk-display-56-roman-italic.woff2'
import neueHaasGroteskDisplay_65MediumWoff from '../fonts/neue-haas-grotesk-display-65-medium.woff'
import neueHaasGroteskDisplay_65MediumWoff2 from '../fonts/neue-haas-grotesk-display-65-medium.woff2'
import neueHaasGroteskDisplay_66MediumItalicWoff from '../fonts/neue-haas-grotesk-display-66-medium-italic.woff'
import neueHaasGroteskDisplay_66MediumItalicWoff2 from '../fonts/neue-haas-grotesk-display-66-medium-italic.woff2'
import neueHaasGroteskText_55RomanWoff from '../fonts/neue-haas-grotesk-text-55-roman.woff'
import neueHaasGroteskText_55RomanWoff2 from '../fonts/neue-haas-grotesk-text-55-roman.woff2'
import neueHaasGroteskText_56RomanItalicWoff from '../fonts/neue-haas-grotesk-text-56-roman-italic.woff'
import neueHaasGroteskText_56RomanItalicWoff2 from '../fonts/neue-haas-grotesk-text-56-roman-italic.woff2'
import neueHaasGroteskText_65MediumWoff from '../fonts/neue-haas-grotesk-text-65-medium.woff'
import neueHaasGroteskText_65MediumWoff2 from '../fonts/neue-haas-grotesk-text-65-medium.woff2'
import neueHaasGroteskText_66MediumItalicWoff from '../fonts/neue-haas-grotesk-text-66-medium-italic.woff'
import neueHaasGroteskText_66MediumItalicWoff2 from '../fonts/neue-haas-grotesk-text-66-medium-italic.woff2'
import speziaMonospaceSemiMonoMediumWoff from '../fonts/spezia-monospace-semi-mono-medium.woff'
import speziaMonospaceSemiMonoMediumWoff2 from '../fonts/spezia-monospace-semi-mono-medium.woff2'

export const fontsToPreload = [
    neueHaasGroteskDisplay_55RomanWoff2,
    neueHaasGroteskDisplay_65MediumWoff2,
    neueHaasGroteskText_55RomanWoff2,
    neueHaasGroteskText_65MediumWoff2,
    speziaMonospaceSemiMonoMediumWoff2,
]

interface Typeface {
    fontFamily: string
    url: {
        woff2: string
        woff: string
    }
    fontWeight: number
    fontStyle: string
}

export const typefaces: Typeface[] = [
    {
        fontFamily: fontPrimary,
        url: {
            woff2: neueHaasGroteskDisplay_55RomanWoff2,
            woff: neueHaasGroteskDisplay_55RomanWoff,
        },
        fontStyle: 'normal',
        fontWeight: fontTheme.weights.medium,
    },
    {
        fontFamily: fontPrimary,
        url: {
            woff2: neueHaasGroteskDisplay_56RomanItalicWoff2,
            woff: neueHaasGroteskDisplay_56RomanItalicWoff,
        },
        fontStyle: 'italic',
        fontWeight: fontTheme.weights.medium,
    },
    {
        fontFamily: fontPrimary,
        url: {
            woff2: neueHaasGroteskDisplay_65MediumWoff2,
            woff: neueHaasGroteskDisplay_65MediumWoff,
        },
        fontStyle: 'normal',
        fontWeight: fontTheme.weights.semiBold,
    },
    {
        fontFamily: fontPrimary,
        url: {
            woff2: neueHaasGroteskDisplay_66MediumItalicWoff2,
            woff: neueHaasGroteskDisplay_66MediumItalicWoff,
        },
        fontStyle: 'italic',
        fontWeight: fontTheme.weights.semiBold,
    },
    {
        fontFamily: fontSecondary,
        url: {
            woff2: neueHaasGroteskText_55RomanWoff2,
            woff: neueHaasGroteskText_55RomanWoff,
        },
        fontStyle: 'normal',
        fontWeight: fontTheme.weights.medium,
    },
    {
        fontFamily: fontSecondary,
        url: {
            woff2: neueHaasGroteskText_56RomanItalicWoff2,
            woff: neueHaasGroteskText_56RomanItalicWoff,
        },
        fontStyle: 'italic',
        fontWeight: fontTheme.weights.medium,
    },
    {
        fontFamily: fontSecondary,
        url: {
            woff2: neueHaasGroteskText_65MediumWoff2,
            woff: neueHaasGroteskText_65MediumWoff,
        },
        fontStyle: 'normal',
        fontWeight: fontTheme.weights.semiBold,
    },
    {
        fontFamily: fontSecondary,
        url: {
            woff2: neueHaasGroteskText_66MediumItalicWoff2,
            woff: neueHaasGroteskText_66MediumItalicWoff,
        },
        fontStyle: 'italic',
        fontWeight: fontTheme.weights.semiBold,
    },
    {
        fontFamily: fontTertiary,
        url: {
            woff2: speziaMonospaceSemiMonoMediumWoff2,
            woff: speziaMonospaceSemiMonoMediumWoff,
        },
        fontStyle: 'normal',
        fontWeight: fontTheme.weights.semiBold,
    },
]
